/* SNEAP core: money formatting, add to cart, cart-mode routing, scroll-to-buy, focus trap helpers */
(function () {
  var S = (window.SNEAP = window.SNEAP || {});
  if (S.__core) return;
  S.__core = true;

  S.root = (S.root || '/').replace(/\/?$/, '/');
  S.url = function (path) { return S.root + String(path).replace(/^\//, ''); };

  /* Money in the store's own format */
  S.money = function (cents) {
    var fmt = S.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function group(n, dec, th, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(sep);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = group(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = group(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = group(cents, 2, ' ', ','); break;
      default: v = group(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  };

  S.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  S.reduceMotion = function () { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); };

  /* Toast message */
  var toastEl, toastTimer;
  S.toast = function (msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sn-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  };

  /* Scroll lock + focus trap for drawers and modals */
  var openStack = [];
  S.lock = function (el, opener) {
    openStack.push({ el: el, opener: opener || document.activeElement });
    document.documentElement.classList.add('sn-lock');
  };
  S.unlock = function (el) {
    for (var i = openStack.length - 1; i >= 0; i--) {
      if (openStack[i].el === el) {
        var o = openStack.splice(i, 1)[0];
        if (o.opener && o.opener.focus && document.contains(o.opener)) { try { o.opener.focus({ preventScroll: true }); } catch (e) {} }
        break;
      }
    }
    if (!openStack.length) document.documentElement.classList.remove('sn-lock');
  };
  document.addEventListener('keydown', function (e) {
    if (!openStack.length) return;
    var top = openStack[openStack.length - 1].el;
    if (e.key === 'Escape') {
      var c = top.querySelector('[data-sn-close]');
      if (c) { e.preventDefault(); c.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(top.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (n) {
      return n.offsetWidth > 0 || n.offsetHeight > 0;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Cart helpers */
  S.fetchCart = function () {
    return fetch(S.url('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  };
  S.updateCount = function (cart) {
    var skip = S.protectionVariant || 0;
    var n = 0;
    (cart.items || []).forEach(function (it) { if (it.variant_id !== skip && !(S.hideCountHandle && it.handle === S.hideCountHandle)) n += it.quantity; });
    document.querySelectorAll('[data-sn-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  };

  /* After any add to cart: open the drawer or go to the cart page */
  S.afterAdd = function (data) {
    document.dispatchEvent(new CustomEvent('sneap:cart-updated', { detail: { added: data } }));
    if (S.cartMode === 'drawer' && S.cart && typeof S.cart.open === 'function') {
      return S.cart.refresh().then(function () { S.cart.open(); });
    }
    window.location.href = S.cartUrl || S.url('cart');
  };

  /* Add items: [{id, quantity, properties}] */
  S.addToCart = function (items, btn, opts) {
    opts = opts || {};
    var label = btn && (btn.querySelector('[data-label]') || btn);
    var original = label ? label.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    if (label && btn.dataset.adding) label.textContent = btn.dataset.adding;
    return fetch(S.url('cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || (S.t||{}).error || 'Error'); return d; }); })
      .then(function (data) {
        if (label && btn.dataset.added) label.textContent = btn.dataset.added;
        if (opts.stay) {
          document.dispatchEvent(new CustomEvent('sneap:cart-updated', { detail: { added: data } }));
          if (S.cart && S.cart.refresh) S.cart.refresh();
          else S.fetchCart().then(S.updateCount);
          return data;
        }
        return S.afterAdd(data, btn);
      })
      .catch(function (err) { S.toast(err && err.message ? err.message : ((S.t||{}).add_error || 'Could not add to cart. Please try again.')); throw err; })
      .finally(function () {
        setTimeout(function () {
          if (!btn) return;
          btn.disabled = false; btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy');
          if (label) label.innerHTML = original;
        }, 900);
      });
  };

  /* Any element with data-sn-add="variantId:qty,variantId:qty" */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sn-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var items = btn.getAttribute('data-sn-add').split(',').filter(Boolean).map(function (p) {
      var parts = p.split(':');
      return { id: Number(parts[0]), quantity: Number(parts[1] || 1) };
    });
    S.addToCart(items, btn).catch(function () {});
  });

  /* Links to the product you're on scroll to the buy area */
  function norm(p) { try { p = decodeURIComponent(p); } catch (e) {} return p.replace(/\/$/, '').replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/products\/)/i, ''); }
  S.scrollToBuy = function () {
    var buy = document.querySelector('[data-sn-buy-area]');
    if (!buy || !buy.offsetParent) return false;
    var top = buy.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, top), behavior: S.reduceMotion() ? 'auto' : 'smooth' });
    buy.classList.remove('sn-flash'); void buy.offsetWidth; buy.classList.add('sn-flash');
    return true;
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var force = a.hasAttribute('data-sn-scroll-buy');
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (!force) {
      if (url.origin !== location.origin || url.pathname.indexOf('/products/') === -1) return;
      if (norm(url.pathname) !== norm(location.pathname) || url.hash) return;
    }
    if (location.pathname.indexOf('/products/') === -1 && !force) return;
    if (S.scrollToBuy()) e.preventDefault();
  });

  /* Keep header counts right after Shopify / Horizon cart events */
  document.addEventListener('shopify:cart:lines-update', function () {
    if (S.cart && S.cart.refresh) {
      S.cart.refresh().then(function () { if (S.cartMode === 'drawer' && S.cart.open) S.cart.open(); });
    } else S.fetchCart().then(S.updateCount);
  });
})();
